import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable()
export class AuthService {

  constructor(public readonly http: HttpClient) {}

  refreshToken(url: string): Observable<any> {
    return this.http.get(url);
  }
}
